<template>
  <div class="m-card-title">
    <slot />
  </div>
</template>

<style scoped>
.m-card-title {
  padding: var(--m-space-4) var(--m-space-4) 0;
  font-size: var(--m-font-size-lg);
  font-weight: 600;
  line-height: 1.4;
}
</style>
